// Dependencies
import {
  TIPOS_MARGEN_REQUEST,
  TIPOS_MARGEN_OK,
  TIPOS_MARGEN_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TIPOS_MARGEN_REQUEST:
      return { ...state, loading: true };
    case TIPOS_MARGEN_ERROR:
      return {
        ...state,
        refreshing: false,
        loading: false,
        error: action.payload.error,
      };
    case TIPOS_MARGEN_OK:
      return {
        ...state,
        refreshing: false,
        loading: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
